import React, { useEffect, useState } from 'react';
import styles from './TransferInfo.module.css';
import {
  BaseStyles,
  Button,
  Heading,
  Input,
  ToastMessage,
  Box,
  Flex,
  Field,
  Text,
} from 'rimble-ui';
import { TOKEN_TYPE } from '../../constants';

function TransferInfo(props) {
  const [fileUploadState, setFileUploadState] = useState('');
  const inputReference = React.createRef();

  const fileUploadAction = () => inputReference.current.click();

  const getAsText = (fileToRead) => {
    let reader = new FileReader();
    // Handle errors load
    reader.onload = (event) => {
      let csv = event.target.result;
      let count = 0;
      while (!/[0-9]/.test(csv[csv.length - 1])) {
        csv = csv.slice(0, -1);
        count++;
        if (count > 10) break;
      }

      props.onChangereceiversAndIdsInputVal(csv);
    };
    reader.onerror = (event) => {
      if (event.target.error.name == 'NotReadableError') {
        alert('Cannot read file !');
      }
    };
    // Read file into memory as UTF-8
    reader.readAsText(fileToRead);
  };

  const fileUploadInputChange = (e) => {
    setFileUploadState(e.target.files[0]);
    if (window.FileReader) {
      // FileReader are supported.
      getAsText(e.target.files[0]);
    } else {
      alert('FileReader are not supported in this browser.');
    }
  };

  return (
    <BaseStyles>
      <Flex className={styles.tokenAddress}>
        <Box>
          <Flex>
            <Box>
              <Heading as='h3'>Token address:</Heading>
            </Box>
          </Flex>
          <Flex>
            <Box>
              <Input
                className={styles.tokenAddressInput}
                type='text'
                required={true}
                placeholder='ex: 0xD5525D397898e5502075Ea5E830d8914f6F0affe'
                value={props.tokenAddressInputVal}
                onChange={(event) => {
                  props.onChangeTokenAddressInputVal(event.target.value);
                }}
              />
            </Box>
          </Flex>
          <Flex>
            <Box>
              <Button
                disabled={props.tokenAddressLoading}
                mainColor='black'
                mt={1}
                icon='Description'
                iconpos='right'
                onClick={() => {
                  props.loadToken();
                }}
              >
                Load
              </Button>
            </Box>
          </Flex>

          <Flex>
            <Box>
              {props.tokenAddressError ? (
                <Text className={styles.error}>Invalid Address</Text>
              ) : props.tokenAddressLoading ? (
                <Text>Loading...</Text>
              ) : props.tokenAmt !== null && props.tokenSymbol !== null ? (
                props.tokenType === TOKEN_TYPE.ERC721 ? (
                  <Text className={styles.loadTokenText}>
                    You have: {props.tokenAmt} {props.tokenSymbol}
                  </Text>
                ) : props.tokenType === TOKEN_TYPE.ERC1155 ? (
                  <>
                    <Text className={styles.loadTokenText}>
                      Loaded ERC1155. Token Uri Preview: {props.erc1155TokenUri}
                    </Text>

                    <Field
                      label={
                        'Max Token Id: ' +
                        props.maxERC1155TokenId +
                        '. Now showing: ' +
                        (props.maxERC1155TokenId - 10000 > 0
                          ? props.maxERC1155TokenId - 10000
                          : 0) +
                        ' - ' +
                        props.maxERC1155TokenId
                      }
                      mt={3}
                    >
                      <Input
                        className={styles.tokenIdMaxInput}
                        type='text'
                        required={true}
                        placeholder='ex: 10000'
                        value={props.tokenMaxIdInputVal}
                        onChange={(event) => {
                          props.onChangeTokenMaxIdInputVal(event.target.value);
                        }}
                      />
                      <Button
                        className={styles.queryAccountERC1155Tokens}
                        icon='ModeEdit'
                        iconpos='right'
                        mainColor='black'
                        onClick={() => {
                          props.queryAccountERC1155Tokens();
                        }}
                      >
                        Set
                      </Button>
                    </Field>

                    {props.ownedERC1155Tokens.map((ownedERC1155Token, i) => {
                      console.log('Tokenid', ownedERC1155Token.tokenId);
                      return (
                        <Text
                          className={styles.loadTokenText}
                          key={'ownedERC1155Tokens' + i}
                        >
                          Token Id: {ownedERC1155Token.tokenId}, Balance:{' '}
                          {ownedERC1155Token.balance.toString()}
                        </Text>
                      );
                    })}
                  </>
                ) : null
              ) : null}
            </Box>
          </Flex>
        </Box>
      </Flex>

      {props.tokenName && props.tokenSymbol && props.tokenAmt ? (
        <Flex className={styles.receiversAndIdsRoot}>
          <Box>
            <Flex>
              <Box>
                <Heading as='h3'>Receivers and Token Ids:</Heading>
              </Box>
            </Flex>
            <Flex>
              <Box>
                {props.tokenType === TOKEN_TYPE.ERC721 ? (
                  <Text className={styles.instructions}>
                    Enter one address and token id in {props.tokenSymbol}{' '}
                    separated by comma on each line. For CSV file, instead of
                    comma, put each attribute in a new column.
                  </Text>
                ) : props.tokenType === TOKEN_TYPE.ERC1155 ? (
                  <Text className={styles.instructions}>
                    Enter one address, one token id and amount in{' '}
                    {props.tokenSymbol} separated by comma on each line. For CSV
                    file, instead of comma, put each attribute in a new column.
                  </Text>
                ) : props.tokenType === TOKEN_TYPE.ERC20 ? (
                  <Text className={styles.instructions}>
                    Enter one address and amount in {props.tokenSymbol}{' '}
                    separated by comma on each line. For CSV file, instead of
                    comma, put each attribute in a new column.
                  </Text>
                ) : null}
                <input
                  type='file'
                  accept='.csv'
                  hidden
                  ref={inputReference}
                  onChange={fileUploadInputChange}
                />
                <Button
                  className={styles.uploadCsv}
                  icon='FileUpload'
                  iconpos='right'
                  mainColor='black'
                  size='small'
                  onClick={() => {
                    fileUploadAction();
                  }}
                >
                  Upload CSV
                </Button>
                <Text>{fileUploadState.name}</Text>
              </Box>
            </Flex>
            <Flex>
              <Box>
                <textarea
                  className={styles.receiversAndIdsTextarea}
                  placeholder={
                    props.tokenType === TOKEN_TYPE.ERC721
                      ? `0xD5525D397898e5502075Ea5E830d8914f6F0affe,1
0x56A9f1E860031C15b029072D503f3485d7caFB3E,2
0x6d16Ab0C5756F987dDe086D8a60dd48a4C523949,3
                  `
                      : props.tokenType === TOKEN_TYPE.ERC1155
                      ? `0xD5525D397898e5502075Ea5E830d8914f6F0affe,1,34
0x56A9f1E860031C15b029072D503f3485d7caFB3E,2,98
0x6d16Ab0C5756F987dDe086D8a60dd48a4C523949,3,1`
                      : props.tokenType === TOKEN_TYPE.ERC20
                      ? `0xD5525D397898e5502075Ea5E830d8914f6F0affe,1
0x56A9f1E860031C15b029072D503f3485d7caFB3E,98
0x6d16Ab0C5756F987dDe086D8a60dd48a4C523949,2`
                      : null
                  }
                  rows={10}
                  value={props.receiversAndIdsInputVal}
                  onChange={(event) => {
                    props.onChangereceiversAndIdsInputVal(event.target.value);
                  }}
                />
              </Box>
            </Flex>
            <Flex>
              <Box>
                {props.approvedAsOperator ? (
                  <Button
                    disabled={props.sendTokensLoading}
                    mainColor='black'
                    icon='Send'
                    iconpos='right'
                    onClick={() => {
                      props.sendTokens((sendTokensTx) => {
                        window.toastProvider.addMessage(
                          'Processing payment...',
                          {
                            secondaryMessage: 'Check progress on Etherscan',
                            actionHref:
                              'https://etherscan.io/tx/' + sendTokensTx,
                            actionText: 'Check',
                            variant: 'processing',
                          }
                        );
                      });
                    }}
                  >
                    Send
                  </Button>
                ) : (
                  <Button
                    disabled={props.approvedAsOperatorLoading}
                    mainColor='black'
                    icon='Send'
                    iconpos='right'
                    onClick={() => {
                      props.approveSmartContract();
                    }}
                  >
                    {props.approvedAsOperatorLoading ? 'Approving' : 'Approve'}
                  </Button>
                )}

                <>
                  <ToastMessage.Provider
                    ref={(node) => (window.toastProvider = node)}
                  />
                </>
              </Box>
            </Flex>
            <Flex mb={10}>
              <Box>
                {props.sendTokensError && props.sendTokensErrorType === "INVALID_TOKENS" ? (
                  <>
                    <Text className={styles.error}>
                      Either you do not own a token specified or token id does not
                      exist. Additionally, double check you have pasted the
                      address and token ids in the correct format.
                    </Text>
                  </>
                ) : 
                props.sendTokensError && props.sendTokensErrorType === "INSUFFICIENT_BALANCE" ? (
                  <>
                    <Text className={styles.error}>
                      Insufficient ERC20 balance. Additionally, double check you have pasted the
                      address and token amounts in the correct format.
                    </Text>
                  </>
                ) : 
                props.sendTokensLoading ? (
                  <Text>Loading...</Text>
                ) : null}
              </Box>
            </Flex>
          </Box>
        </Flex>
      ) : null}
    </BaseStyles>
  );
}

export default TransferInfo;
